import React from 'react'
import { View, StyleSheet } from 'react-native'
import { Text } from 'react-native-paper'
import { useTranslation } from 'react-i18next'

interface PaymentTimerProps {
  timeLeft: number
}

export const PaymentTimer: React.FC<PaymentTimerProps> = ({ timeLeft }) => {
  const { t } = useTranslation('payment')

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60)
    const secs = seconds % 60
    return `${mins}:${secs.toString().padStart(2, '0')}`
  }

  return (
    <View style={styles.timerContainer}>
      <Text variant="bodyMedium" style={styles.timerLabel}>
        {t('time-remaining')}:
      </Text>
      <Text variant="headlineMedium" style={styles.timer}>
        {formatTime(timeLeft)}
      </Text>
    </View>
  )
}

const styles = StyleSheet.create({
  timerContainer: {
    alignItems: 'center',
    marginBottom: 20,
  },
  timerLabel: {
    marginBottom: 4,
  },
  timer: {
    textAlign: 'center',
  },
})
